<div class="overflow-hidden">
  <div>
    <div class="row">
      <div class="col-12">

          <div class="d-flex align-items-end justify-content-between w-100">

          <div
            class="w-100 d-flex align-items-center overflow-hidden list-style-none justify-content-end"
          >
            <ul class="breadcrumb list-style-none d-flex m-b-1 m-t-0 p-l-0">
              @for (url of pageInfo?.['urls']; track url.url;let index =
              $index,last = $last ) { @if(!last){

              <li class="breadcrumb-item" [routerLink]="url.url">
                <a [routerLink]="url.url">{{ url.title }}</a>
              </li>
              }@else {
              <li class="breadcrumb-item active text-primary">{{ url.title }}</li>
              } }
            </ul>
          </div>        
          </div>
      </div>
      <!-- <div
        class="col-lg-4 col-sm-6 text-right position-relative align-items-center justify-content-end gap-20 d-none d-sm-flex"
      > -->
<!--         <div class="d-flex align-items-center">
          <div>
            <span class="text-uppercase f-s-12">This Month</span>
            <h6 class="text-primary m-0 f-s-18 f-w-400">$58,356</h6>
          </div>
          <div class="d-flex flex-column m-l-8">
            <apx-chart
              [series]="breadcrumbOption.series"
              [chart]="breadcrumbOption.chart"
              [dataLabels]="breadcrumbOption.dataLabels"
              [plotOptions]="breadcrumbOption.plotOptions"
              [yaxis]="breadcrumbOption.yaxis"
              [legend]="breadcrumbOption.legend"
              [fill]="breadcrumbOption.fill"
              [stroke]="breadcrumbOption.stroke"
              [tooltip]="breadcrumbOption.tooltip"
              [xaxis]="breadcrumbOption.xaxis"
              [grid]="breadcrumbOption.grid"
            >
            </apx-chart>
          </div>
        </div> -->
        <!-- 2 -->
<!--         <div class="d-flex align-items-center">
          <div>
            <span class="text-uppercase f-s-12">Last Month</span>
            <h6 class="text-accent m-0 f-s-18 f-w-400">$48,356</h6>
          </div>
          <div class="d-flex flex-column m-l-8">
            <apx-chart
              [series]="breadcrumb2Option.series"
              [chart]="breadcrumb2Option.chart"
              [dataLabels]="breadcrumb2Option.dataLabels"
              [plotOptions]="breadcrumb2Option.plotOptions"
              [yaxis]="breadcrumb2Option.yaxis"
              [legend]="breadcrumb2Option.legend"
              [fill]="breadcrumb2Option.fill"
              [stroke]="breadcrumb2Option.stroke"
              [tooltip]="breadcrumb2Option.tooltip"
              [xaxis]="breadcrumb2Option.xaxis"
              [grid]="breadcrumb2Option.grid"
            >
            </apx-chart>
          </div>
        </div> -->
      <!-- </div> -->
    </div>
  </div>
</div>
